import React from 'react';
import './../index.css';

export class LevelText extends React.Component {

  render() {
    const text = this.props.text;
      return (
        <>
          {
            /*
              * text section
              */
          }
          <div className='levelText'>
            <p>
              {text}
            </p>
          </div>
        </>
      );
  }


}
